import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';
import { Link } from 'react-router-dom';
import { FaPlus, FaEdit } from 'react-icons/fa';

function Categories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const snapshot = await getDocs(collection(db, 'resource_categories'));
        setCategories(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      } catch (err) {
        setError("Erreur lors du chargement des catégories");
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  if (loading) return <div>Chargement...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="categories-container">
      <div className="page-header">
        <h1>Gestion des Catégories</h1>
        <Link to="/admin/categories/new" className="add-button">
          <FaPlus /> Ajouter une catégorie
        </Link>
      </div>

      <div className="categories-list">
        {categories.length === 0 ? (
          <p>Aucune catégorie disponible</p>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Nom</th>
                <th>Cours associé</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {categories.map(category => (
                <tr key={category.id}>
                  <td>{category.name}</td>
                  <td>{category.courseId}</td>
                  <td>
                    <Link 
                      to={`/admin/categories/edit/${category.id}`}
                      className="edit-button"
                    >
                      <FaEdit /> Modifier
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default Categories;